import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Modal from 'react-bootstrap/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faColumns } from '@fortawesome/free-solid-svg-icons'

function AddGridRow({ onAddRow, isLoading = false, remainingCapacity = 20, totalColumnCount = 0 }) {
  const [showModal, setShowModal] = useState(false)

  const handleAddRow = (columnCount) => {
    onAddRow(columnCount)
    setShowModal(false)
  }

  // Don't show the add button if we've reached the limit
  if (remainingCapacity <= 0) {
    return (
      <Card className="mb-4" style={{ border: '2px dashed #dee2e6', backgroundColor: '#f8f9fa' }}>
        <Card.Body className="text-center py-4">
          <p className="text-muted mb-0">
            Dashboard has reached the maximum of 20 charts.
          </p>
        </Card.Body>
      </Card>
    )
  }

  return (
    <>
      <Card className="mb-4" style={{ border: '2px dashed #dee2e6', backgroundColor: '#f8f9fa' }}>
        <Card.Body className="d-flex align-items-center justify-content-center py-4">
          <Button
            variant="primary"
            onClick={() => setShowModal(true)}
            className="d-flex align-items-center justify-content-center"
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            <span>{isLoading ? 'Adding...' : 'Add Row'}</span>
          </Button>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Choose Column Layout</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3">Select how many columns you want in this row:</p>
          {remainingCapacity < 4 && (
            <div className="alert alert-warning mb-3">
              <small>
                <strong>Note:</strong> You have {remainingCapacity} chart{remainingCapacity !== 1 ? 's' : ''} remaining 
                out of 20 total. Currently using {totalColumnCount} chart{totalColumnCount !== 1 ? 's' : ''}.
              </small>
            </div>
          )}
          <div className="d-grid gap-3">
            {[1, 2, 3, 4].map((columnCount) => {
              const isDisabled = columnCount > remainingCapacity || isLoading
              
              return (
                <Button
                  key={columnCount}
                  variant={isDisabled ? "secondary" : "outline-primary"}
                  size="lg"
                  onClick={() => handleAddRow(columnCount)}
                  className="d-flex align-items-center justify-content-center py-3"
                  disabled={isDisabled}
                >
                  <FontAwesomeIcon icon={faColumns} className="me-2" />
                  {columnCount} Column{columnCount > 1 ? 's' : ''}
                  <div className="ms-3 d-flex gap-1">
                    {Array.from({ length: columnCount }, (_, i) => (
                      <div
                        key={i}
                        style={{
                          width: `${60 / columnCount}px`,
                          height: '20px',
                          backgroundColor: isDisabled ? '#6c757d' : 'white',
                          border: `1px solid ${isDisabled ? '#6c757d' : 'var(--bs-primary)'}`,
                          borderRadius: '2px'
                        }}
                      />
                    ))}
                  </div>
                  {columnCount > remainingCapacity && (
                    <span className="ms-auto text-muted small">
                      (Exceeds limit)
                    </span>
                  )}
                </Button>
              )
            })}
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AddGridRow